import "./CodiceFiscalePage.css";
import { t } from "../../services/formatters";
import { useCodiceFiscalePage } from "./useCodiceFiscalePage";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { Riepilogo } from "../../components/Riepilogo";
import { TextInput } from "../../components/TextInput";
import { ErrorModal } from "../../components/ErrorModal";
import { EditAppointmentModal } from "../../components/EditAppointmentModal";
import { useEffect } from "react";
import { useComponentMetric } from "../../lib/otel";

export const CodiceFiscalePage = () => {
    const { next, read, onCfChange, isDatiUtenteReady, isCfFetchStart, getCfInputState, fetchErrorMessage, fetchError, setFetchError, showModal, closeModal } = useCodiceFiscalePage();

const metric = useComponentMetric("codice-fiscale");
    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/fissa-appuntamento/codice-fiscale",
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    useEffect(() => {
        if (fetchError) {
            metric.trackError(fetchErrorMessage || "errore verifica codice fiscale");
        }
    }, [fetchError]);


    return (
        <div id="filiali-page">
            <Breadcrumb />

            {/* riepilogo */}
            {read("filialeScelta") && <Riepilogo />}

            <div className={`section white-box input-box-component`}>
                <h2>{t("ci_conosciamo")}</h2>
                <p className={`input-box-subtitle`}>&nbsp;</p>
                <TextInput state={getCfInputState()} name="codiceFiscale" placeholder={t("inserisci_cf")} value={read("codiceFiscale")} onChange={onCfChange} maxLength={16}></TextInput>
            </div>

            <div className="text-center text-small">
                <strong>
                    Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati
                    personali{" "}
                    <a target="_blank" href="/share/pdfsni/PRIVACY_FA.PDF">
                        <u>qui scaricabile</u>
                    </a>
                </strong>
            </div>

            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isDatiUtenteReady()} onClick={next} classList="btn-responsive always-style" loading={isCfFetchStart()} text={`${t("avanti")}`} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>

            <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal} />
        </div>
    );
};
